export default class EndScreenEvent {
    constructor(type) {
        this.type = type;
    }
}

EndScreenEvent.CLOSE_REQUEST = "EndScreenEvent.CLOSE_REQUEST";